import { Panel } from '@/components/Panel';
import { PasswordForm } from '@/components/form/PasswordForm';

/**
 * Modification du mot de passe local de l'utilisateur connecté. Un compte sans mot de passe n'arrive pas ici : RequireAuth
 * l'envoie d'abord sur DefinePasswordPage
 */
export function PasswordPage() {
  return (
    <Panel className="max-w-md p-6">
      <PasswordForm definition={false} />
    </Panel>
  );
}
